var exports = {
  "kL": "xfb577c5e--f478de--container",
  "wx": "xfb577c5e--f478de--header",
  "M1": "xfb577c5e--f478de--stats",
};

module.exports = exports;
